// Libs
import React from 'react'
import _ from 'lodash'

// CSS
import "./styles.scss"

// Env
import env from '../../../../env'

const MyCasesPageFilterField = ({ index, type, section, option, input }) => {
  let className = 'my-cases-page-filter-field'
  let checked = false

  switch (type) {
    case 'checkbox':
      className += ' my-cases-page-filter-field--checkbox'
      checked = input.value.indexOf(option.value) !== -1
      break;
    case 'radio':
      className += ' my-cases-page-filter-field--radio'
      checked = input.checked
      break;
    default:
  }

  if (checked) className += ' my-cases-page-filter-field--checked'

  const handleChange = (e) => {
    switch (type) {
      case 'checkbox':
        const newValue = [...input.value]

        if (e.target.checked) {
          newValue.push(option.value)
        } else {
          newValue.splice(newValue.indexOf(option.value), 1)
        }

        input.onChange(_.isEmpty(newValue) ? '' : newValue)
        break;
      case 'radio':
        input.onChange(e)
        break;
      default:
    }
  }

  return (
    <label className={className}>
      <input
        {...input}
        checked={checked}
        type={type}
        onChange={handleChange} />
      <div><span /></div>
      <p title={option.label.length > 30 ? option.label : ''}>{option.label}</p>
    </label>
  )
}

export default MyCasesPageFilterField
